// SPDX-License-Identifier: GPL-2.0-or-later
// Modos de treino (D-86, D-87): opções da sala de treino, compartilhadas entre o cliente, a API e o
// servidor do jogo (RN-TRN-04, RN-TRN-06).
export const TRAINING_MODES_LIST = ['attack', 'defense', 'escape', 'capture'];
/** Mapas de treino (D-87): lista fixa, a mesma nos quatro modos, independente da rotação Casual. */
export const TRAINING_MAPS = ['2 versus 2 (duel)', '3x3 (duel)', 'cebs park', 'pari2', 'the cover 4'];
/** Limites das opções por modo (RN-TRN-04). */
export const TRAINING_LIMITS = {
    attack: { bots: [1, 4], allies: [0, 0] },
    defense: { bots: [1, 5], allies: [0, 2] },
    escape: { bots: [1, 4], allies: [0, 0] },
    capture: { bots: [0, 3], allies: [0, 0] },
};
/** Opções novas de um modo: o meio dos limites, nível 3, power-ups desligados, início variado. */
export function defaultTraining(mode) {
    const l = TRAINING_LIMITS[mode];
    return { mode, bots: mode === 'capture' ? 2 : Math.min(2, l.bots[1]), allies: mode === 'defense' ? 1 : 0, level: 3, powerups: false, sameStart: false };
}
/** Opções dentro dos limites do modo. */
export function clampTraining(c) {
    const l = TRAINING_LIMITS[c.mode];
    const clamp = (v, [lo, hi]) => Math.max(lo, Math.min(hi, Math.trunc(v)));
    return { ...c, bots: clamp(c.bots, l.bots), allies: clamp(c.allies, l.allies), level: clamp(c.level, [0, 5]) };
}
/** Vagas da sala de treino: cabem os bots dos papéis e humanos dos dois lados (bots não ocupam vaga, OG-445). */
export const TRAINING_MAX_PLAYERS = 16;
//# sourceMappingURL=training.js.map